// extracted by mini-css-extract-plugin
export default {"root":"CurrencyInput__root","input":"CurrencyInput__input","icon":"CurrencyInput__icon brandColor__font","disabled":"CurrencyInput__disabled"};